var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              !_vm.designerModalVisible
                ? [
                    _c(
                      "div",
                      { staticClass: "table-page-search-wrapper" },
                      [
                        _c(
                          "a-form",
                          {
                            attrs: { layout: "inline" },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchQuery.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据编号",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入单据编号",
                                          },
                                          model: {
                                            value: _vm.queryParam.bill_no,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "bill_no",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.bill_no",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "往来单位",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder: "请选择往来单位",
                                              "allow-clear": "",
                                              "show-search": "",
                                            },
                                            model: {
                                              value: _vm.queryParam.organ_id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "organ_id",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.organ_id",
                                            },
                                          },
                                          _vm._l(
                                            _vm.organList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.supplier) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据日期",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-range-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            format: "YYYY-MM-DD",
                                            placeholder: [
                                              "开始日期",
                                              "结束日期",
                                            ],
                                          },
                                          on: { change: _vm.onDateChange },
                                          model: {
                                            value:
                                              _vm.queryParam.bill_date_range,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "bill_date_range",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryParam.bill_date_range",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-page-search-submitButtons",
                                    },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.searchQuery },
                                        },
                                        [_vm._v("查询")]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          attrs: { icon: "printer" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goReportPrint(
                                                "ITEM_DETAIL",
                                                "收支项明细",
                                                _vm.dataSource
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("打印")]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          attrs: { icon: "setting" },
                                          on: {
                                            click: _vm.openTemplateDesigner,
                                          },
                                        },
                                        [_vm._v("模板设置")]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          attrs: { icon: "download" },
                                          on: { click: _vm.exportExcel },
                                        },
                                        [_vm._v("导出")]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          on: { click: _vm.handleToggleSearch },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.toggleSearchStatus
                                                  ? "收起"
                                                  : "展开"
                                              ) +
                                              "\n                  "
                                          ),
                                          _c("a-icon", {
                                            attrs: {
                                              type: _vm.toggleSearchStatus
                                                ? "up"
                                                : "down",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm.toggleSearchStatus
                              ? [
                                  _c(
                                    "a-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "财务人员",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder:
                                                      "请选择财务人员",
                                                    "allow-clear": "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam.finance_id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "finance_id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.finance_id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.financeList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(item.name) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "操作员",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder: "请选择操作员",
                                                    "allow-clear": "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam
                                                        .operator_id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "operator_id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.operator_id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.operatorList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item.userName
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "账户信息",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder: "请选择账户",
                                                    "allow-clear": "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam.account_id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "account_id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.account_id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.accountList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(item.name) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "单据类别",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder:
                                                      "请选择单据类别",
                                                    "allow-clear": "",
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onBillCategoryChange,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam
                                                        .bill_category,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "bill_category",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.bill_category",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: { value: "收入" },
                                                    },
                                                    [_vm._v("收入")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: { value: "支出" },
                                                    },
                                                    [_vm._v("支出")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "收支项目",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder:
                                                      "请选择收支项目",
                                                    "allow-clear": "",
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.handleTypeChange,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam
                                                        .in_out_item_id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "in_out_item_id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.in_out_item_id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.inOutItemList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(item.name) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "备注",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c("a-input", {
                                                attrs: {
                                                  placeholder: "请输入备注",
                                                },
                                                model: {
                                                  value: _vm.queryParam.remark,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryParam,
                                                      "remark",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryParam.remark",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                            _c(
                              "a-row",
                              {
                                staticStyle: { "margin-top": "8px" },
                                attrs: { gutter: 24 },
                              },
                              [
                                _c("a-col", { attrs: { md: 24, sm: 24 } }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "green",
                                        "font-weight": "bold",
                                        "margin-right": "20px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                收入合计：￥" +
                                          _vm._s(_vm.totalIncome.toFixed(2)) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                支出合计：￥" +
                                          _vm._s(_vm.totalExpense.toFixed(2)) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "section",
                      { ref: "print", attrs: { id: "reportPrint" } },
                      [
                        _c(
                          "a-table",
                          {
                            ref: "table",
                            attrs: {
                              bordered: "",
                              size: "middle",
                              rowKey: "id",
                              columns: _vm.columns,
                              dataSource: _vm.dataSource,
                              pagination: false,
                              scroll: _vm.scroll,
                              loading: _vm.loading,
                            },
                            on: { change: _vm.handleTableChange },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "billNoSlot",
                                  fn: function (text, record) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.goToDetail(record)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(text))]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "itemInAmountSlot",
                                  fn: function (text, record) {
                                    return [
                                      record.type === "收入"
                                        ? _c(
                                            "span",
                                            { staticStyle: { color: "green" } },
                                            [_vm._v(_vm._s(text))]
                                          )
                                        : _c("span", [_vm._v(_vm._s(text))]),
                                    ]
                                  },
                                },
                                {
                                  key: "itemOutAmountSlot",
                                  fn: function (text, record) {
                                    return [
                                      record.type === "支出"
                                        ? _c(
                                            "span",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v(_vm._s(text))]
                                          )
                                        : _c("span", [_vm._v(_vm._s(text))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4268454056
                            ),
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "customTitle" },
                                slot: "customTitle",
                              },
                              [
                                _c(
                                  "a-popover",
                                  {
                                    attrs: {
                                      trigger: "click",
                                      placement: "right",
                                    },
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "content" },
                                      [
                                        _c(
                                          "a-checkbox-group",
                                          {
                                            attrs: {
                                              defaultValue:
                                                _vm.settingDataIndex,
                                            },
                                            on: { change: _vm.onColChange },
                                            model: {
                                              value: _vm.settingDataIndex,
                                              callback: function ($$v) {
                                                _vm.settingDataIndex = $$v
                                              },
                                              expression: "settingDataIndex",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-row",
                                              {
                                                staticStyle: { width: "600px" },
                                              },
                                              [
                                                _vm._l(
                                                  _vm.defColumns,
                                                  function (item, index) {
                                                    return [
                                                      [
                                                        _c(
                                                          "a-col",
                                                          {
                                                            attrs: { span: 6 },
                                                          },
                                                          [
                                                            item.dataIndex ===
                                                            "rowIndex"
                                                              ? _c(
                                                                  "a-checkbox",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        item.dataIndex,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            item.dataIndex !==
                                                            "rowIndex"
                                                              ? _c(
                                                                  "a-checkbox",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        item.dataIndex,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "j-ellipsis",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            item.title,
                                                                          length: 10,
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "a-row",
                                              {
                                                staticStyle: {
                                                  "padding-top": "10px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-col",
                                                  [
                                                    _vm._v(
                                                      "\n                      恢复默认列配置："
                                                    ),
                                                    _c(
                                                      "a-button",
                                                      {
                                                        attrs: {
                                                          type: "link",
                                                          size: "small",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.handleRestDefault,
                                                        },
                                                      },
                                                      [_vm._v("恢复默认")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("a-icon", {
                                      attrs: { type: "setting" },
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "a-row",
                          {
                            staticStyle: {
                              "margin-top": "8px",
                              "text-align": "right",
                            },
                            attrs: { gutter: 24 },
                          },
                          [
                            _c(
                              "a-col",
                              { attrs: { md: 24, sm: 24 } },
                              [
                                _c("a-pagination", {
                                  attrs: {
                                    size: "small",
                                    "show-size-changer": "",
                                    "show-quick-jumper": "",
                                    current: _vm.ipagination.current,
                                    "page-size": _vm.ipagination.pageSize,
                                    "page-size-options":
                                      _vm.ipagination.pageSizeOptions,
                                    total: _vm.ipagination.total,
                                    "show-total": (total) => `共 ${total} 条`,
                                  },
                                  on: {
                                    change: _vm.paginationChange,
                                    showSizeChange:
                                      _vm.paginationShowSizeChange,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "buildOptionText",
                                        fn: function (props) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(props.value) + "条/页"
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    198454938
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("financial-detail", { ref: "modalDetail" }),
                  ]
                : _c("div", { staticClass: "embedded-designer-container" }, [
                    _c(
                      "div",
                      { staticClass: "embedded-designer-header" },
                      [
                        _c("span", { staticClass: "designer-title" }, [
                          _vm._v("模板设计器 - 收支项明细"),
                        ]),
                        _c(
                          "a-button",
                          {
                            attrs: { icon: "close", size: "small" },
                            on: { click: _vm.closeTemplateDesigner },
                          },
                          [_vm._v("关闭")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "embedded-designer-body" },
                      [
                        _vm.designerComponent
                          ? _c(_vm.designerComponent, {
                              tag: "component",
                              attrs: {
                                reportType: "ITEM_DETAIL",
                                reportTitle: "收支项明细",
                                reportData: _vm.getPreviewData(),
                                embedded: true,
                              },
                              on: {
                                close: _vm.closeTemplateDesigner,
                                "refresh-data": _vm.handleRefreshData,
                              },
                            })
                          : _vm.designerLoading
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  padding: "100px",
                                },
                              },
                              [
                                _c("a-spin", {
                                  attrs: {
                                    size: "large",
                                    tip: "正在加载设计器...",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }